import React, { useCallback, useState } from "react";
import {
  AdapterConfig,
  AdapterPreviewModel,
  AdapterSimulateModel,
} from "../../../../../domain/models/city-adapter-config";
import * as S from "../styles";
import ValoresFixosSection from "./valores-fixos-section";
import DeParaSection from "./de-para-section";
import TransformacoesSection from "./transformacoes-section";
import CamposRemoverSection from "./campos-remover-section";
import JsonEditorSection from "./json-editor-section";
import PreviewPanel from "./preview-panel";
import SimulationPanel from "./simulation-panel";

type Props = {
  createMode: boolean;
  editMode: "form" | "json";
  onEditModeChange: (mode: "form" | "json") => void;
  config: AdapterConfig;
  onConfigChange: (config: AdapterConfig) => void;
  onSave: () => void;
  onDelete?: () => void;
  saving: boolean;
  preview: AdapterPreviewModel | null;
  previewLoading: boolean;
  previewError: string | null;
  simulation: AdapterSimulateModel | null;
  simulationLoading: boolean;
  onSimulate: () => void;
};

const ConfigEditor: React.FC<Props> = ({
  createMode,
  editMode,
  onEditModeChange,
  config,
  onConfigChange,
  onSave,
  onDelete,
  saving,
  preview,
  previewLoading,
  previewError,
  simulation,
  simulationLoading,
  onSimulate,
}) => {
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  const handleJsonChange = useCallback((newConfig: AdapterConfig): void => {
    onConfigChange(newConfig);
  }, [onConfigChange]);

  return (
    <div>
      {/* Preview */}
      <PreviewPanel
        preview={preview}
        loading={previewLoading}
        error={previewError}
      />

      {/* Toggle de modo */}
      <S.SectionCard>
        <S.ModeToggle>
          <S.ModeTab $active={editMode === "form"} type="button" onClick={() => onEditModeChange("form")}>
            📋 Formulário
          </S.ModeTab>
          <S.ModeTab $active={editMode === "json"} type="button" onClick={() => onEditModeChange("json")}>
            {"{}"} Editor JSON
          </S.ModeTab>
        </S.ModeToggle>
      </S.SectionCard>

      {/* Conteúdo por modo */}
      {editMode === "form" ? (
        <>
          <ValoresFixosSection
            valores={config.valoresFixos}
            onChange={(valoresFixos) => onConfigChange({ ...config, valoresFixos })}
          />
          <DeParaSection
            dePara={config.deParaChaves}
            onChange={(deParaChaves) => onConfigChange({ ...config, deParaChaves })}
          />
          <TransformacoesSection
            transformacoes={config.transformacoes}
            onChange={(transformacoes) => onConfigChange({ ...config, transformacoes })}
          />
          <CamposRemoverSection
            campos={config.camposRemover}
            onChange={(camposRemover) => onConfigChange({ ...config, camposRemover })}
          />
        </>
      ) : (
        <JsonEditorSection config={config} onChange={handleJsonChange} />
      )}

      {/* Simulação */}
      <SimulationPanel
        simulation={simulation}
        loading={simulationLoading}
        onSimulate={onSimulate}
        disabled={!preview && !createMode}
      />

      {/* Ações */}
      <S.FooterActions>
        {onDelete && !showDeleteConfirm && (
          <S.DangerButton type="button" onClick={() => setShowDeleteConfirm(true)}>Excluir</S.DangerButton>
        )}
        {showDeleteConfirm && (
          <>
            <span style={{ fontSize: 13, color: "#EB5757", fontFamily: "Poppins, sans-serif" }}>
              Tem certeza?
            </span>
            <S.DangerButton type="button" onClick={() => { onDelete?.(); setShowDeleteConfirm(false); }}>
              Sim, excluir
            </S.DangerButton>
            <S.SmallButton type="button" onClick={() => setShowDeleteConfirm(false)}>Cancelar</S.SmallButton>
          </>
        )}
        <S.CreateButton type="button" onClick={onSave} disabled={saving}>
          {saving ? "Salvando..." : "💾 Salvar"}
        </S.CreateButton>
      </S.FooterActions>
    </div>
  );
};

export default ConfigEditor;
